// extracted by mini-css-extract-plugin
export default {"formContainer":"QROrders_formContainer__nqqcP","statusSelect":"QROrders_statusSelect__E+rFJ","clearButton":"QROrders_clearButton__ttSi6"};